import { LPC_ULTRA_LUX_CAMPAIGN_EARN_KEY } from 'loyalty/constants/loyaltyEarn'

interface LoyaltyEarnKeyBedbankOptions {
  propertyCountryCode: string | undefined
  currentRegionCode: string
}

interface LoyaltyEarnKeyAlwaysOnOptions {
  propertyCountryCode: string | undefined
  currentRegionCode: string
  isUltraLux: boolean
}

// Add additional loyalty product types here
type LoyaltyProductTypeWithOptions = 'hotel_lpc' | 'hotel_lpp_eps'

type LoyaltyEarnKeyConfig =
  | { loyaltyProductType: 'hotel_lpc', options: LoyaltyEarnKeyAlwaysOnOptions }
  | { loyaltyProductType: 'hotel_lpp_eps', options: LoyaltyEarnKeyBedbankOptions }
  // Add other verticals / loyalty product types here
  | { loyaltyProductType: Exclude<App.LoyaltyProductType, LoyaltyProductTypeWithOptions>, options?: undefined }

function getLoyaltyEarnKey(config: LoyaltyEarnKeyConfig): string | undefined {
  switch (config.loyaltyProductType) {
    case 'hotel_lpc':
    {
      if (config.options.isUltraLux) {
        return LPC_ULTRA_LUX_CAMPAIGN_EARN_KEY
      }
      return undefined
    }
    default:
      return undefined
  }
}

export default getLoyaltyEarnKey
